/**
 * Public, source-backed fixtures. Generated from data/content-route-manifest.csv.
 * Keep demo-only mutable state in demo-catalog.ts; do not mutate these records.
 */
export type ContentLocale = 'it' | 'en';

export interface LocalizedRecord {
  title: string;
  slug: string;
  route: string;
  sourceUrl: string;
  sourceWpId: number | null;
  sourceDate: string | null;
  sourceModified: string | null;
  media: readonly string[];
  primaryMedia: string | null;
}

export interface PublicContentRecord {
  id: string;
  categoryId: string | null;
  batch: string;
  translationStatus: string;
  languages: Partial<Record<ContentLocale, LocalizedRecord>>;
}

export interface PublicCategoryRecord extends PublicContentRecord {
  media: string;
  focalPoint: 'center';
}

export const publicCategories: readonly PublicCategoryRecord[] = [
  {
    "id": "cat-laboratory-equipment",
    "categoryId": "cat-laboratory-equipment",
    "batch": "05",
    "translationStatus": "en_category_source_missing",
    "languages": {
      "it": {
        "title": "ATTREZZATURE DA LABORATORIO",
        "slug": "attrezzature-da-laboratorio",
        "route": "/it/categoria/attrezzature-da-laboratorio",
        "sourceUrl": "https://www.esamed.it/categoria/attrezzature-da-laboratorio/",
        "sourceWpId": 107,
        "sourceDate": null,
        "sourceModified": null,
        "media": [],
        "primaryMedia": null
      }
    },
    "media": "/media/source/images/Attrezzatura-da-laboratorio.png",
    "focalPoint": "center"
  },
  {
    "id": "cat-infertility",
    "categoryId": "cat-infertility",
    "batch": "05",
    "translationStatus": "en_category_source_missing",
    "languages": {
      "it": {
        "title": "INFERTILITA'",
        "slug": "infertilita",
        "route": "/it/categoria/infertilita",
        "sourceUrl": "https://www.esamed.it/categoria/infertilita/",
        "sourceWpId": 146,
        "sourceDate": null,
        "sourceModified": null,
        "media": [],
        "primaryMedia": null
      }
    },
    "media": "/media/source/images/infertilita-categoria-3.png",
    "focalPoint": "center"
  },
  {
    "id": "cat-microbiology",
    "categoryId": "cat-microbiology",
    "batch": "05",
    "translationStatus": "en_category_source_missing",
    "languages": {
      "it": {
        "title": "MICROBIOLOGIA",
        "slug": "microbiologia",
        "route": "/it/categoria/microbiologia",
        "sourceUrl": "https://www.esamed.it/categoria/microbiologia/",
        "sourceWpId": 140,
        "sourceDate": null,
        "sourceModified": null,
        "media": [],
        "primaryMedia": null
      }
    },
    "media": "/media/source/images/microbiologia-categoria-1064x745.png",
    "focalPoint": "center"
  },
  {
    "id": "cat-poct",
    "categoryId": "cat-poct",
    "batch": "05",
    "translationStatus": "en_category_source_missing",
    "languages": {
      "it": {
        "title": "POINT OF CARE TESTING",
        "slug": "point-of-care-testing",
        "route": "/it/categoria/point-of-care-testing",
        "sourceUrl": "https://www.esamed.it/categoria/point-of-care-testing/",
        "sourceWpId": 15,
        "sourceDate": null,
        "sourceModified": null,
        "media": [],
        "primaryMedia": null
      }
    },
    "media": "/media/source/images/POCT-categoria-1.png",
    "focalPoint": "center"
  },
  {
    "id": "cat-preanalytics",
    "categoryId": "cat-preanalytics",
    "batch": "05",
    "translationStatus": "en_category_source_missing",
    "languages": {
      "it": {
        "title": "PREANALITICA",
        "slug": "preanalitica",
        "route": "/it/categoria/preanalitica",
        "sourceUrl": "https://www.esamed.it/categoria/preanalitica/",
        "sourceWpId": 156,
        "sourceDate": null,
        "sourceModified": null,
        "media": [],
        "primaryMedia": null
      }
    },
    "media": "/media/source/images/preanalitica-categoria.png",
    "focalPoint": "center"
  },
  {
    "id": "cat-collection-systems",
    "categoryId": "cat-collection-systems",
    "batch": "05",
    "translationStatus": "it_en_source_available",
    "languages": {
      "it": {
        "title": "SISTEMI DI PRELIEVO",
        "slug": "sistemi-di-prelievo",
        "route": "/it/categoria/sistemi-di-prelievo",
        "sourceUrl": "https://www.esamed.it/categoria/sistemi-di-prelievo/",
        "sourceWpId": 136,
        "sourceDate": null,
        "sourceModified": null,
        "media": [],
        "primaryMedia": null
      },
      "en": {
        "title": "COLLECTION SYSTEMS",
        "slug": "collection-systems",
        "route": "/en/category/collection-systems",
        "sourceUrl": "https://www.esamed.it/en/category/collection-systems/",
        "sourceWpId": 166,
        "sourceDate": null,
        "sourceModified": null,
        "media": [],
        "primaryMedia": null
      }
    },
    "media": "/media/source/images/Prelievo-esamed-categoria-1.png",
    "focalPoint": "center"
  },
  {
    "id": "cat-transport-systems",
    "categoryId": "cat-transport-systems",
    "batch": "05",
    "translationStatus": "it_en_source_available",
    "languages": {
      "it": {
        "title": "SOLUZIONI PER IL TRASPORTO",
        "slug": "soluzioni-per-trasporto",
        "route": "/it/categoria/soluzioni-per-trasporto",
        "sourceUrl": "https://www.esamed.it/categoria/soluzioni-per-trasporto/",
        "sourceWpId": 42,
        "sourceDate": null,
        "sourceModified": null,
        "media": [],
        "primaryMedia": null
      },
      "en": {
        "title": "TRANSPORT SYSTEMS",
        "slug": "transport-systems",
        "route": "/en/category/transport-systems",
        "sourceUrl": "https://www.esamed.it/en/category/transport-systems/",
        "sourceWpId": 123,
        "sourceDate": null,
        "sourceModified": null,
        "media": [],
        "primaryMedia": null
      }
    },
    "media": "/media/source/images/soluzioni-trasporto-Esamed.png",
    "focalPoint": "center"
  },
  {
    "id": "cat-traceability",
    "categoryId": "cat-traceability",
    "batch": "05",
    "translationStatus": "it_en_source_available",
    "languages": {
      "it": {
        "title": "TRACCIABILITA'",
        "slug": "tracciabilita",
        "route": "/it/categoria/tracciabilita",
        "sourceUrl": "https://www.esamed.it/categoria/tracciabilita/",
        "sourceWpId": 148,
        "sourceDate": null,
        "sourceModified": null,
        "media": [],
        "primaryMedia": null
      },
      "en": {
        "title": "TRACEABILITY",
        "slug": "traceability",
        "route": "/en/category/traceability",
        "sourceUrl": "https://www.esamed.it/en/category/traceability/",
        "sourceWpId": 149,
        "sourceDate": null,
        "sourceModified": null,
        "media": [],
        "primaryMedia": null
      }
    },
    "media": "/media/source/images/Tracciabilita-Esamed.png",
    "focalPoint": "center"
  }
] as const;

export const publicProducts: readonly PublicContentRecord[] = [
  {
    "id": "prd-contenitori-terziari-esamed-endmed",
    "categoryId": "cat-transport-systems",
    "batch": "07G1",
    "translationStatus": "it_en_source_available",
    "languages": {
      "it": {
        "title": "Contenitori terziari – Esamed-Endmed",
        "slug": "contenitori-terziari-esamed-endmed",
        "route": "/it/prodotti/soluzioni-per-trasporto/contenitori-terziari-esamed-endmed",
        "sourceUrl": "https://www.esamed.it/prodotti/soluzioni-per-trasporto/contenitori-terziari-esamed-endmed/",
        "sourceWpId": 5286,
        "sourceDate": "2026-04-30T10:48:05",
        "sourceModified": "2026-04-30T10:56:36",
        "media": [
          "/media/source/images/ES-BIO-M.png"
        ],
        "primaryMedia": "/media/source/images/ES-BIO-M.png"
      },
      "en": {
        "title": "Tertiary container – Esamed-Endmed",
        "slug": "tertiary-container-esamed-endmed",
        "route": "/en/products/transport-systems/tertiary-container-esamed-endmed",
        "sourceUrl": "https://www.esamed.it/en/products/transport-systems/tertiary-container-esamed-endmed/",
        "sourceWpId": 5287,
        "sourceDate": "2026-04-30T10:48:05",
        "sourceModified": "2026-04-30T12:46:25",
        "media": [
          "/media/source/images/ES-BIO-M.png"
        ],
        "primaryMedia": "/media/source/images/ES-BIO-M.png"
      }
    }
  },
  {
    "id": "prd-centrifuga-centric-cf-108r-gr",
    "categoryId": "cat-laboratory-equipment",
    "batch": "07A1",
    "translationStatus": "en_missing; explicit_it_fallback_required",
    "languages": {
      "it": {
        "title": "Centrifuga Centric CF 108 R/GR – Domel",
        "slug": "centrifuga-centric-cf-108r-gr",
        "route": "/it/prodotti/attrezzature-da-laboratorio/centrifuga-centric-cf-108r-gr",
        "sourceUrl": "https://www.esamed.it/prodotti/attrezzature-da-laboratorio/centrifuga-centric-cf-108r-gr/",
        "sourceWpId": 5271,
        "sourceDate": "2026-04-30T10:02:00",
        "sourceModified": "2026-04-30T10:38:57",
        "media": [
          "/media/source/images/centric-108-R-GR-1.png",
          "/media/source/images/centric-108-R-1.png",
          "/media/source/images/centric-108-GR-1.png"
        ],
        "primaryMedia": "/media/source/images/centric-108-R-GR-1.png"
      }
    }
  },
  {
    "id": "prd-eugenio-esamed",
    "categoryId": "cat-transport-systems",
    "batch": "07G2",
    "translationStatus": "it_en_source_available",
    "languages": {
      "it": {
        "title": "Eugenio – ESAMED",
        "slug": "eugenio-esamed",
        "route": "/it/prodotti/soluzioni-per-trasporto/eugenio-esamed",
        "sourceUrl": "https://www.esamed.it/prodotti/soluzioni-per-trasporto/eugenio-esamed/",
        "sourceWpId": 5204,
        "sourceDate": "2026-04-28T15:49:38",
        "sourceModified": "2026-04-28T15:50:23",
        "media": [
          "/media/source/images/Eugenio-Esamed-1.png",
          "/media/source/images/EugenioAperto-scaled.jpg",
          "/media/source/images/Eugenio-1940-scaled.jpg",
          "/media/source/images/Eugenio-1974-scaled.jpg"
        ],
        "primaryMedia": "/media/source/images/Eugenio-Esamed-1.png"
      },
      "en": {
        "title": "Eugenio – ESAMED",
        "slug": "eugenio-2",
        "route": "/en/products/transport-systems/eugenio-2",
        "sourceUrl": "https://www.esamed.it/en/products/transport-systems/eugenio-2/",
        "sourceWpId": 5205,
        "sourceDate": "2026-04-28T15:49:38",
        "sourceModified": "2026-04-30T14:32:04",
        "media": [
          "/media/source/images/Eugenio-Esamed-1.png",
          "/media/source/images/EugenioAperto-scaled.jpg",
          "/media/source/images/Eugenio-1940-scaled.jpg",
          "/media/source/images/Eugenio-1974-scaled.jpg"
        ],
        "primaryMedia": "/media/source/images/Eugenio-Esamed-1.png"
      }
    }
  },
  {
    "id": "prd-poch100i-sysmex",
    "categoryId": "cat-poct",
    "batch": "07D",
    "translationStatus": "en_missing; explicit_it_fallback_required",
    "languages": {
      "it": {
        "title": "POCH-100i – SYSMEX",
        "slug": "poch100i-sysmex",
        "route": "/it/prodotti/point-of-care-testing/poch100i-sysmex",
        "sourceUrl": "https://www.esamed.it/prodotti/point-of-care-testing/poch100i-sysmex/",
        "sourceWpId": 4961,
        "sourceDate": "2026-04-23T08:59:52",
        "sourceModified": "2026-04-30T09:50:25",
        "media": [
          "/media/source/images/POCH-100-1.png"
        ],
        "primaryMedia": "/media/source/images/POCH-100-1.png"
      }
    }
  },
  {
    "id": "prd-ca0ca1-bonraybio",
    "categoryId": "cat-infertility",
    "batch": "07B",
    "translationStatus": "en_missing; explicit_it_fallback_required",
    "languages": {
      "it": {
        "title": "CA0/CA1 – Bonraybio",
        "slug": "ca0ca1-bonraybio",
        "route": "/it/prodotti/infertilita/ca0ca1-bonraybio",
        "sourceUrl": "https://www.esamed.it/prodotti/infertilita/ca0ca1-bonraybio/",
        "sourceWpId": 4950,
        "sourceDate": "2026-04-22T13:31:18",
        "sourceModified": "2026-04-28T16:19:43",
        "media": [
          "/media/source/images/CA0CA1-1.png"
        ],
        "primaryMedia": "/media/source/images/CA0CA1-1.png"
      }
    }
  },
  {
    "id": "prd-centrifuga-mf48-48r-domel",
    "categoryId": "cat-laboratory-equipment",
    "batch": "07A1",
    "translationStatus": "it_en_source_available",
    "languages": {
      "it": {
        "title": "Centrifuga MF 48/48R – Domel",
        "slug": "centrifuga-mf48-48r-domel",
        "route": "/it/prodotti/attrezzature-da-laboratorio/centrifuga-mf48-48r-domel",
        "sourceUrl": "https://www.esamed.it/prodotti/attrezzature-da-laboratorio/centrifuga-mf48-48r-domel/",
        "sourceWpId": 4925,
        "sourceDate": "2026-04-21T15:19:25",
        "sourceModified": "2026-04-28T10:25:38",
        "media": [
          "/media/source/images/centrifuga-MF48-48R.png",
          "/media/source/images/48-48R-tabella.png"
        ],
        "primaryMedia": "/media/source/images/centrifuga-MF48-48R.png"
      },
      "en": {
        "title": "Centrifuge Domel MF48 e MF48 R",
        "slug": "centrifuga-domel-mf48",
        "route": "/en/products/laboratory-equipment/centrifuga-domel-mf48",
        "sourceUrl": "https://www.esamed.it/en/products/sistemi-di-prelievo/centrifuga-domel-mf48/",
        "sourceWpId": 4062,
        "sourceDate": "2023-07-04T11:43:08",
        "sourceModified": "2024-04-16T16:59:36",
        "media": [
          "/media/source/images/centrifuga-350-1.png"
        ],
        "primaryMedia": "/media/source/images/centrifuga-350-1.png"
      }
    }
  },
  {
    "id": "prd-analizzatore-biochimico-a-secco-automatico-sd1",
    "categoryId": "cat-poct",
    "batch": "07D",
    "translationStatus": "en_missing; explicit_it_fallback_required",
    "languages": {
      "it": {
        "title": "SD1 – SEAMATY",
        "slug": "analizzatore-biochimico-a-secco-automatico-sd1",
        "route": "/it/prodotti/point-of-care-testing/analizzatore-biochimico-a-secco-automatico-sd1",
        "sourceUrl": "https://www.esamed.it/prodotti/point-of-care-testing/analizzatore-biochimico-a-secco-automatico-sd1/",
        "sourceWpId": 4893,
        "sourceDate": "2026-04-21T08:54:59",
        "sourceModified": "2026-04-28T17:24:50",
        "media": [
          "/media/source/images/SD1-1.png",
          "/media/source/images/Tabella-SD1.png"
        ],
        "primaryMedia": "/media/source/images/SD1-1.png"
      }
    }
  },
  {
    "id": "prd-r11-plus-bonraybio",
    "categoryId": "cat-infertility",
    "batch": "07B",
    "translationStatus": "en_missing; explicit_it_fallback_required",
    "languages": {
      "it": {
        "title": "R11 PLUS – Bonraybio",
        "slug": "r11-plus-bonraybio",
        "route": "/it/prodotti/infertilita/r11-plus-bonraybio",
        "sourceUrl": "https://www.esamed.it/prodotti/infertilita/r11-plus-bonraybio/",
        "sourceWpId": 4879,
        "sourceDate": "2026-04-20T12:21:16",
        "sourceModified": "2026-04-28T16:17:24",
        "media": [
          "/media/source/images/R11-1.png"
        ],
        "primaryMedia": "/media/source/images/R11-1.png"
      }
    }
  },
  {
    "id": "prd-r10-bonraybio",
    "categoryId": "cat-infertility",
    "batch": "07B",
    "translationStatus": "en_missing; explicit_it_fallback_required",
    "languages": {
      "it": {
        "title": "R10 PLUS – Bonraybio",
        "slug": "r10-bonraybio",
        "route": "/it/prodotti/infertilita/r10-bonraybio",
        "sourceUrl": "https://www.esamed.it/prodotti/infertilita/r10-bonraybio/",
        "sourceWpId": 4871,
        "sourceDate": "2026-04-20T11:07:58",
        "sourceModified": "2026-04-28T16:16:27",
        "media": [
          "/media/source/images/R10-1.png"
        ],
        "primaryMedia": "/media/source/images/R10-1.png"
      }
    }
  },
  {
    "id": "prd-c-kup-bonraybio",
    "categoryId": "cat-infertility",
    "batch": "07B",
    "translationStatus": "en_missing; explicit_it_fallback_required",
    "languages": {
      "it": {
        "title": "C-KUP – Bonraybio",
        "slug": "c-kup-bonraybio",
        "route": "/it/prodotti/infertilita/c-kup-bonraybio",
        "sourceUrl": "https://www.esamed.it/prodotti/infertilita/c-kup-bonraybio/",
        "sourceWpId": 4862,
        "sourceDate": "2026-04-20T10:27:06",
        "sourceModified": "2026-04-28T16:18:33",
        "media": [
          "/media/source/images/c-kup-2.png"
        ],
        "primaryMedia": "/media/source/images/c-kup-2.png"
      }
    }
  },
  {
    "id": "prd-accre8-immunometria",
    "categoryId": "cat-poct",
    "batch": "07D",
    "translationStatus": "en_missing; explicit_it_fallback_required",
    "languages": {
      "it": {
        "title": "ACCRE 8 – WONDFO",
        "slug": "accre8-immunometria",
        "route": "/it/prodotti/point-of-care-testing/accre8-immunometria",
        "sourceUrl": "https://www.esamed.it/prodotti/point-of-care-testing/accre8-immunometria/",
        "sourceWpId": 4835,
        "sourceDate": "2026-04-15T16:36:50",
        "sourceModified": "2026-04-28T17:08:59",
        "media": [
          "/media/source/images/ACCRE8-2.png"
        ],
        "primaryMedia": "/media/source/images/ACCRE8-2.png"
      }
    }
  },
  {
    "id": "prd-esapoct-gestione-poct",
    "categoryId": "cat-traceability",
    "batch": "07H",
    "translationStatus": "en_missing; explicit_it_fallback_required",
    "languages": {
      "it": {
        "title": "ESAPoct applicativo per la gestione POCT – ESAMED",
        "slug": "esapoct-gestione-poct",
        "route": "/it/prodotti/tracciabilita/esapoct-gestione-poct",
        "sourceUrl": "https://www.esamed.it/prodotti/tracciabilita/esapoct-gestione-poct/",
        "sourceWpId": 4802,
        "sourceDate": "2026-04-09T17:15:07",
        "sourceModified": "2026-04-28T15:58:53",
        "media": [
          "/media/source/images/ESAPoct-1.png",
          "/media/source/images/ESApoct-software-e1775749250164.png"
        ],
        "primaryMedia": "/media/source/images/ESAPoct-1.png"
      }
    }
  },
  {
    "id": "prd-samtrace-sistema-esamed-per-la-tracciabilita-delle-provette",
    "categoryId": "cat-traceability",
    "batch": "07H",
    "translationStatus": "en_missing; explicit_it_fallback_required",
    "languages": {
      "it": {
        "title": "SAMtrace sistema per la tracciabilità delle provette – ESAMED",
        "slug": "samtrace-sistema-esamed-per-la-tracciabilita-delle-provette",
        "route": "/it/prodotti/tracciabilita/samtrace-sistema-esamed-per-la-tracciabilita-delle-provette",
        "sourceUrl": "https://www.esamed.it/prodotti/tracciabilita/samtrace-sistema-esamed-per-la-tracciabilita-delle-provette/",
        "sourceWpId": 4793,
        "sourceDate": "2026-04-09T16:27:31",
        "sourceModified": "2026-04-28T16:04:11",
        "media": [
          "/media/source/images/SAMtrace.png",
          "/media/source/images/Login-new.png"
        ],
        "primaryMedia": "/media/source/images/SAMtrace.png"
      }
    }
  },
  {
    "id": "prd-emotrace-tracciabilita-sangue",
    "categoryId": "cat-traceability",
    "batch": "06",
    "translationStatus": "it_en_source_available",
    "languages": {
      "it": {
        "title": "EMOtrace tracciabilità delle sacche di sangue – ESAMED",
        "slug": "emotrace-tracciabilita-sangue",
        "route": "/it/prodotti/tracciabilita/emotrace-tracciabilita-sangue",
        "sourceUrl": "https://www.esamed.it/prodotti/tracciabilita/emotrace-tracciabilita-sangue/",
        "sourceWpId": 4789,
        "sourceDate": "2026-04-09T16:00:02",
        "sourceModified": "2026-04-28T16:00:08",
        "media": [
          "/media/source/images/EMOtrace-2.png",
          "/media/source/images/emotrace-scaled-e1775747461105.png"
        ],
        "primaryMedia": "/media/source/images/EMOtrace-2.png"
      },
      "en": {
        "title": "EMOtrace – ESAMED",
        "slug": "emotrace",
        "route": "/en/products/traceability/emotrace",
        "sourceUrl": "https://www.esamed.it/en/products/traceability/emotrace/",
        "sourceWpId": 4790,
        "sourceDate": "2026-04-09T16:00:02",
        "sourceModified": "2026-04-30T13:52:14",
        "media": [
          "/media/source/images/EMOtrace-2.png",
          "/media/source/images/emotrace-scaled-e1775747461105.png"
        ],
        "primaryMedia": "/media/source/images/EMOtrace-2.png"
      }
    }
  },
  {
    "id": "prd-piastre-refrigeranti-e-piastre-eutettiche-contenitore-terziari",
    "categoryId": "cat-transport-systems",
    "batch": "07G2",
    "translationStatus": "it_en_source_available",
    "languages": {
      "it": {
        "title": "Piastre refrigeranti e piastre eutettiche – ESAMED",
        "slug": "piastre-refrigeranti-e-piastre-eutettiche-contenitore-terziari",
        "route": "/it/prodotti/soluzioni-per-trasporto/piastre-refrigeranti-e-piastre-eutettiche-contenitore-terziari",
        "sourceUrl": "https://www.esamed.it/prodotti/soluzioni-per-trasporto/piastre-refrigeranti-e-piastre-eutettiche-contenitore-terziari/",
        "sourceWpId": 4746,
        "sourceDate": "2026-04-07T16:54:29",
        "sourceModified": "2026-04-28T15:21:05",
        "media": [
          "/media/source/images/Accessori-terziari-esamed-1.png",
          "/media/source/images/Piastre-eutettiche-1.png",
          "/media/source/images/piastre-refrigeranti.png"
        ],
        "primaryMedia": "/media/source/images/Accessori-terziari-esamed-1.png"
      },
      "en": {
        "title": "Cooling Packs and Eutectic Plates – ESAMED",
        "slug": "cooling-plates",
        "route": "/en/products/transport-systems/cooling-plates",
        "sourceUrl": "https://www.esamed.it/en/products/transport-systems/cooling-plates/",
        "sourceWpId": 3086,
        "sourceDate": "2020-10-12T11:50:59",
        "sourceModified": "2026-04-30T15:59:43",
        "media": [
          "/media/source/images/Accessori-terziari-esamed-1.png",
          "/media/source/images/piastre-refrigeranti.png",
          "/media/source/images/Piastre-eutettiche-1.png"
        ],
        "primaryMedia": "/media/source/images/Accessori-terziari-esamed-1.png"
      }
    }
  },
  {
    "id": "prd-accessori-contenitore-secondario-bios",
    "categoryId": "cat-transport-systems",
    "batch": "07G1",
    "translationStatus": "it_en_source_available",
    "languages": {
      "it": {
        "title": "Accessori per contenitori secondari BIOS – ESAMED",
        "slug": "accessori-contenitore-secondario-bios",
        "route": "/it/prodotti/soluzioni-per-trasporto/accessori-contenitore-secondario-bios",
        "sourceUrl": "https://www.esamed.it/prodotti/soluzioni-per-trasporto/accessori-contenitore-secondario-bios/",
        "sourceWpId": 4732,
        "sourceDate": "2026-04-07T14:44:30",
        "sourceModified": "2026-04-28T15:42:14",
        "media": [
          "/media/source/images/Accessori-secondari-Esamed.png",
          "/media/source/images/ES-SP18.png",
          "/media/source/images/telini-1.png",
          "/media/source/images/ES-SP78.png",
          "/media/source/images/Rack-bianco-2.png",
          "/media/source/images/rack-rosso-3.png"
        ],
        "primaryMedia": "/media/source/images/Accessori-secondari-Esamed.png"
      },
      "en": {
        "title": "Accessories for BIOS Secondary Containers – ESAMED",
        "slug": "accessories-for-bios",
        "route": "/en/products/transport-systems/accessories-for-bios",
        "sourceUrl": "https://www.esamed.it/en/products/transport-systems/accessories-for-bios/",
        "sourceWpId": 4747,
        "sourceDate": "2026-04-07T16:54:29",
        "sourceModified": "2026-04-30T15:58:49",
        "media": [
          "/media/source/images/Accessori-secondari-Esamed.png"
        ],
        "primaryMedia": "/media/source/images/Accessori-secondari-Esamed.png"
      }
    }
  },
  {
    "id": "prd-contenitore-secondario-plasmapack",
    "categoryId": "cat-transport-systems",
    "batch": "07G1",
    "translationStatus": "it_en_source_available",
    "languages": {
      "it": {
        "title": "Contenitori secondari Plasmapack – ESAMED",
        "slug": "contenitore-secondario-plasmapack",
        "route": "/it/prodotti/soluzioni-per-trasporto/contenitore-secondario-plasmapack",
        "sourceUrl": "https://www.esamed.it/prodotti/soluzioni-per-trasporto/contenitore-secondario-plasmapack/",
        "sourceWpId": 4726,
        "sourceDate": "2026-04-07T11:46:34",
        "sourceModified": "2026-04-22T12:51:41",
        "media": [
          "/media/source/images/plasmapack-esamed.png",
          "/media/source/images/plasmapack-tabella.png"
        ],
        "primaryMedia": "/media/source/images/plasmapack-esamed.png"
      },
      "en": {
        "title": "Plasmapack Secondary Containers – ESAMED",
        "slug": "plasmapack-secondary-container",
        "route": "/en/products/transport-systems/plasmapack-secondary-container",
        "sourceUrl": "https://www.esamed.it/en/products/transport-systems/plasmapack-secondary-container/",
        "sourceWpId": 4715,
        "sourceDate": "2026-04-07T10:16:21",
        "sourceModified": "2026-04-30T16:24:33",
        "media": [
          "/media/source/images/plasmapack-esamed.png"
        ],
        "primaryMedia": "/media/source/images/plasmapack-esamed.png"
      }
    }
  },
  {
    "id": "prd-contenitore-secondario-busta-campioni-biologici",
    "categoryId": "cat-transport-systems",
    "batch": "07G1",
    "translationStatus": "it_en_source_available",
    "languages": {
      "it": {
        "title": "Contenitori secondari Busta – ESAMED",
        "slug": "contenitore-secondario-busta-campioni-biologici",
        "route": "/it/prodotti/soluzioni-per-trasporto/contenitore-secondario-busta-campioni-biologici",
        "sourceUrl": "https://www.esamed.it/prodotti/soluzioni-per-trasporto/contenitore-secondario-busta-campioni-biologici/",
        "sourceWpId": 4720,
        "sourceDate": "2026-04-07T11:04:48",
        "sourceModified": "2026-04-22T12:49:57",
        "media": [
          "/media/source/images/Busta-biosicurezza.png",
          "/media/source/images/Busta.png"
        ],
        "primaryMedia": "/media/source/images/Busta-biosicurezza.png"
      },
      "en": {
        "title": "Bag Secondary Containers – ESAMED",
        "slug": "bag-secondary-containers",
        "route": "/en/products/transport-systems/bag-secondary-containers",
        "sourceUrl": "https://www.esamed.it/en/products/transport-systems/bag-secondary-containers/",
        "sourceWpId": 4733,
        "sourceDate": "2026-04-07T14:44:30",
        "sourceModified": "2026-04-30T16:14:48",
        "media": [
          "/media/source/images/Busta-biosicurezza.png"
        ],
        "primaryMedia": "/media/source/images/Busta-biosicurezza.png"
      }
    }
  },
  {
    "id": "prd-contenitore-secondario-kartell-campioni-biologici",
    "categoryId": "cat-transport-systems",
    "batch": "07G1",
    "translationStatus": "en_missing; explicit_it_fallback_required",
    "languages": {
      "it": {
        "title": "Contenitori secondari – Kartell",
        "slug": "contenitore-secondario-kartell-campioni-biologici",
        "route": "/it/prodotti/soluzioni-per-trasporto/contenitore-secondario-kartell-campioni-biologici",
        "sourceUrl": "https://www.esamed.it/prodotti/soluzioni-per-trasporto/contenitore-secondario-kartell-campioni-biologici/",
        "sourceWpId": 4714,
        "sourceDate": "2026-04-07T10:16:21",
        "sourceModified": "2026-04-28T15:44:51",
        "media": [
          "/media/source/images/Contenitore-secondario-kartell-1.png",
          "/media/source/images/kartell.png"
        ],
        "primaryMedia": "/media/source/images/Contenitore-secondario-kartell-1.png"
      }
    }
  },
  {
    "id": "prd-contenitore-terziario-a-basso-spessore-samed",
    "categoryId": "cat-transport-systems",
    "batch": "07G1",
    "translationStatus": "it_en_source_available",
    "languages": {
      "it": {
        "title": "Contenitori terziari a basso spessore – ESAMED",
        "slug": "contenitore-terziario-a-basso-spessore-samed",
        "route": "/it/prodotti/soluzioni-per-trasporto/contenitore-terziario-a-basso-spessore-samed",
        "sourceUrl": "https://www.esamed.it/prodotti/soluzioni-per-trasporto/contenitore-terziario-a-basso-spessore-samed/",
        "sourceWpId": 4684,
        "sourceDate": "2026-04-02T13:10:55",
        "sourceModified": "2026-04-28T15:26:05",
        "media": [
          "/media/source/images/contenitori-terziari-a-basso-spessore-1.png",
          "/media/source/images/tabella-basso-spessore.png",
          "/media/source/images/ES-E-BIO-3.png",
          "/media/source/images/ES-E-EMO-2.png",
          "/media/source/images/ES-E-FAB-2.png"
        ],
        "primaryMedia": "/media/source/images/contenitori-terziari-a-basso-spessore-1.png"
      },
      "en": {
        "title": "Slimline Tertiary Containers – ESAMED",
        "slug": "slimline-tertiary-containers",
        "route": "/en/products/transport-systems/slimline-tertiary-containers",
        "sourceUrl": "https://www.esamed.it/en/products/transport-systems/slimline-tertiary-containers/",
        "sourceWpId": 4788,
        "sourceDate": "2026-04-09T15:56:11",
        "sourceModified": "2026-04-30T14:43:06",
        "media": [
          "/media/source/images/contenitori-terziari-a-basso-spessore-1.png",
          "/media/source/images/ES-E-BIO-3.png",
          "/media/source/images/ES-E-EMO-2.png",
          "/media/source/images/ES-E-FAB-2.png"
        ],
        "primaryMedia": "/media/source/images/contenitori-terziari-a-basso-spessore-1.png"
      }
    }
  },
  {
    "id": "prd-celle-frigorifere",
    "categoryId": "cat-laboratory-equipment",
    "batch": "07A1",
    "translationStatus": "en_missing; explicit_it_fallback_required",
    "languages": {
      "it": {
        "title": "Celle frigorifere – Evermed",
        "slug": "celle-frigorifere",
        "route": "/it/prodotti/attrezzature-da-laboratorio/celle-frigorifere",
        "sourceUrl": "https://www.esamed.it/prodotti/attrezzature-da-laboratorio/celle-frigorifere/",
        "sourceWpId": 4635,
        "sourceDate": "2026-03-26T11:06:12",
        "sourceModified": "2026-04-28T11:51:53",
        "media": [
          "/media/source/images/celle-1.png",
          "/media/source/images/MRC-2.png",
          "/media/source/images/MFC-2.png"
        ],
        "primaryMedia": "/media/source/images/celle-1.png"
      }
    }
  },
  {
    "id": "prd-frigoriferi-congelatori-portatili",
    "categoryId": "cat-laboratory-equipment",
    "batch": "07A2",
    "translationStatus": "en_missing; explicit_it_fallback_required",
    "languages": {
      "it": {
        "title": "Frigoriferi e congelatori portatili – Evermed",
        "slug": "frigoriferi-congelatori-portatili",
        "route": "/it/prodotti/attrezzature-da-laboratorio/frigoriferi-congelatori-portatili",
        "sourceUrl": "https://www.esamed.it/prodotti/attrezzature-da-laboratorio/frigoriferi-congelatori-portatili/",
        "sourceWpId": 4618,
        "sourceDate": "2026-03-26T09:50:00",
        "sourceModified": "2026-05-06T14:29:51",
        "media": [
          "/media/source/images/frigoriferi-portatili-1.png",
          "/media/source/images/PRF-1.png",
          "/media/source/images/IC-2.png",
          "/media/source/images/EPRF-C-1.png",
          "/media/source/images/EPRF-HC-1.png"
        ],
        "primaryMedia": "/media/source/images/frigoriferi-portatili-1.png"
      }
    }
  },
  {
    "id": "prd-frigoriferi-medicali-a-due-temperature",
    "categoryId": "cat-laboratory-equipment",
    "batch": "07A2",
    "translationStatus": "en_missing; explicit_it_fallback_required",
    "languages": {
      "it": {
        "title": "Frigoriferi medicali a due temperature – Evermed",
        "slug": "frigoriferi_medicali_a_due_temperature",
        "route": "/it/prodotti/attrezzature-da-laboratorio/frigoriferi_medicali_a_due_temperature",
        "sourceUrl": "https://www.esamed.it/prodotti/attrezzature-da-laboratorio/frigoriferi_medicali_a_due_temperature/",
        "sourceWpId": 4602,
        "sourceDate": "2026-03-26T09:06:11",
        "sourceModified": "2026-04-28T11:19:33",
        "media": [
          "/media/source/images/frigoriferi-combinati-1.png",
          "/media/source/images/LCRR-2.png",
          "/media/source/images/MPRR-2.png",
          "/media/source/images/LCRF-1.png"
        ],
        "primaryMedia": "/media/source/images/frigoriferi-combinati-1.png"
      }
    }
  },
  {
    "id": "prd-frigoemoteche-congelatori",
    "categoryId": "cat-laboratory-equipment",
    "batch": "07A2",
    "translationStatus": "en_missing; explicit_it_fallback_required",
    "languages": {
      "it": {
        "title": "Frigoemoteche e congelatori – Evermed",
        "slug": "frigoemoteche-congelatori",
        "route": "/it/prodotti/attrezzature-da-laboratorio/frigoemoteche-congelatori",
        "sourceUrl": "https://www.esamed.it/prodotti/attrezzature-da-laboratorio/frigoemoteche-congelatori/",
        "sourceWpId": 4588,
        "sourceDate": "2026-03-25T16:56:56",
        "sourceModified": "2026-04-28T11:44:42",
        "media": [
          "/media/source/images/frigoemoteche-1.png",
          "/media/source/images/BBRV-3.png",
          "/media/source/images/LFG-MD-1.png",
          "/media/source/images/LF-MD.png",
          "/media/source/images/LDF-MD-1.png",
          "/media/source/images/PDF-MD-1.png"
        ],
        "primaryMedia": "/media/source/images/frigoemoteche-1.png"
      }
    }
  },
  {
    "id": "prd-congelatori-da-laboratorio",
    "categoryId": "cat-laboratory-equipment",
    "batch": "07A1",
    "translationStatus": "en_missing; explicit_it_fallback_required",
    "languages": {
      "it": {
        "title": "Congelatori da Laboratorio – Evermed",
        "slug": "congelatori-da-laboratorio",
        "route": "/it/prodotti/attrezzature-da-laboratorio/congelatori-da-laboratorio",
        "sourceUrl": "https://www.esamed.it/prodotti/attrezzature-da-laboratorio/congelatori-da-laboratorio/",
        "sourceWpId": 4560,
        "sourceDate": "2026-03-25T15:04:20",
        "sourceModified": "2026-04-28T10:59:53",
        "media": [
          "/media/source/images/congelatori-da-laboratorio.png",
          "/media/source/images/LFG-2.png",
          "/media/source/images/LF-2.png",
          "/media/source/images/LDF-1.png",
          "/media/source/images/PDF-1.png",
          "/media/source/images/ULF-2.png",
          "/media/source/images/BLCF-3.png",
          "/media/source/images/LCDF-2.png",
          "/media/source/images/LCSDF-1.png",
          "/media/source/images/ULCF-1.png"
        ],
        "primaryMedia": "/media/source/images/congelatori-da-laboratorio.png"
      }
    }
  },
  {
    "id": "prd-flashbot-pudu-smanno-camminatore",
    "categoryId": "cat-preanalytics",
    "batch": "07E",
    "translationStatus": "en_missing; explicit_it_fallback_required",
    "languages": {
      "it": {
        "title": "FlashBot PUDU – SMANNO",
        "slug": "flashbot_pudu_smanno_camminatore",
        "route": "/it/prodotti/preanalitica/flashbot_pudu_smanno_camminatore",
        "sourceUrl": "https://www.esamed.it/prodotti/preanalitica/flashbot_pudu_smanno_camminatore/",
        "sourceWpId": 4547,
        "sourceDate": "2026-03-25T12:13:57",
        "sourceModified": "2026-04-24T16:32:24",
        "media": [
          "/media/source/images/pudu-smanno-1.png"
        ],
        "primaryMedia": "/media/source/images/pudu-smanno-1.png"
      }
    }
  },
  {
    "id": "prd-tt-2000-s-iqvision-endmed",
    "categoryId": "cat-preanalytics",
    "batch": "07E",
    "translationStatus": "en_missing; explicit_it_fallback_required",
    "languages": {
      "it": {
        "title": "TT 2000 S IQ Vision – ENDMED",
        "slug": "tt-2000-s-iqvision-endmed",
        "route": "/it/prodotti/preanalitica/tt-2000-s-iqvision-endmed",
        "sourceUrl": "https://www.esamed.it/prodotti/preanalitica/tt-2000-s-iqvision-endmed/",
        "sourceWpId": 4542,
        "sourceDate": "2026-03-25T11:51:18",
        "sourceModified": "2026-04-24T16:42:37",
        "media": [
          "/media/source/images/TT2000S_IQ.png"
        ],
        "primaryMedia": "/media/source/images/TT2000S_IQ.png"
      }
    }
  },
  {
    "id": "prd-tt-2000-s-endmed",
    "categoryId": "cat-preanalytics",
    "batch": "07E",
    "translationStatus": "en_missing; explicit_it_fallback_required",
    "languages": {
      "it": {
        "title": "TT 2000 S – ENDMED",
        "slug": "tt-2000-s_endmed",
        "route": "/it/prodotti/preanalitica/tt-2000-s_endmed",
        "sourceUrl": "https://www.esamed.it/prodotti/preanalitica/tt-2000-s_endmed/",
        "sourceWpId": 4538,
        "sourceDate": "2026-03-25T11:40:41",
        "sourceModified": "2026-04-24T16:40:27",
        "media": [
          "/media/source/images/TT2000S.png"
        ],
        "primaryMedia": "/media/source/images/TT2000S.png"
      }
    }
  },
  {
    "id": "prd-x3-pro-semen-quality-analyzer",
    "categoryId": "cat-infertility",
    "batch": "07B",
    "translationStatus": "en_missing; explicit_it_fallback_required",
    "languages": {
      "it": {
        "title": "X3 PRO Semen Quality Analyzer – Bonraybio",
        "slug": "x3-pro-semen-quality-analyzer",
        "route": "/it/prodotti/infertilita/x3-pro-semen-quality-analyzer",
        "sourceUrl": "https://www.esamed.it/prodotti/infertilita/x3-pro-semen-quality-analyzer/",
        "sourceWpId": 4398,
        "sourceDate": "2025-03-25T08:21:33",
        "sourceModified": "2026-04-28T16:14:12",
        "media": [
          "/media/source/images/X3-1.png"
        ],
        "primaryMedia": "/media/source/images/X3-1.png"
      }
    }
  },
  {
    "id": "prd-tipos-olpaso",
    "categoryId": "cat-preanalytics",
    "batch": "07E",
    "translationStatus": "en_missing; explicit_it_fallback_required",
    "languages": {
      "it": {
        "title": "TipoS – OLPASO",
        "slug": "tipos-olpaso",
        "route": "/it/prodotti/preanalitica/tipos-olpaso",
        "sourceUrl": "https://www.esamed.it/prodotti/preanalitica/tipos-olpaso/",
        "sourceWpId": 4394,
        "sourceDate": "2025-03-25T08:01:58",
        "sourceModified": "2026-04-24T16:44:07",
        "media": [
          "/media/source/images/TIPOS-1.png"
        ],
        "primaryMedia": "/media/source/images/TIPOS-1.png"
      }
    }
  },
  {
    "id": "prd-mindray-fa-n-series",
    "categoryId": "cat-microbiology",
    "batch": "07C",
    "translationStatus": "en_missing; explicit_it_fallback_required",
    "languages": {
      "it": {
        "title": "FA-N series strumenti per emocolture – Mindray",
        "slug": "mindray-fa-n-series",
        "route": "/it/prodotti/microbiologia/mindray-fa-n-series",
        "sourceUrl": "https://www.esamed.it/prodotti/microbiologia/mindray-fa-n-series/",
        "sourceWpId": 4390,
        "sourceDate": "2025-03-25T07:38:06",
        "sourceModified": "2026-04-28T16:42:16",
        "media": [
          "/media/source/images/FA-N-series-1.png",
          "/media/source/images/FA-N20-1.png",
          "/media/source/images/FA-N60.png",
          "/media/source/images/FA-N120-2.png",
          "/media/source/images/FA-N480-1.png",
          "/media/source/images/bottiglie-nuove-1.png"
        ],
        "primaryMedia": "/media/source/images/FA-N-series-1.png"
      }
    }
  },
  {
    "id": "prd-sg1",
    "categoryId": "cat-poct",
    "batch": "07D",
    "translationStatus": "en_missing; explicit_it_fallback_required",
    "languages": {
      "it": {
        "title": "SG1 – SEAMATY",
        "slug": "sg1",
        "route": "/it/prodotti/point-of-care-testing/sg1",
        "sourceUrl": "https://www.esamed.it/prodotti/point-of-care-testing/sg1/",
        "sourceWpId": 4358,
        "sourceDate": "2024-12-08T12:34:46",
        "sourceModified": "2026-04-28T17:06:35",
        "media": [
          "/media/source/images/SG1-2.png",
          "/media/source/images/BG10N.png"
        ],
        "primaryMedia": "/media/source/images/SG1-2.png"
      }
    }
  },
  {
    "id": "prd-mindray-af-300",
    "categoryId": "cat-microbiology",
    "batch": "07C",
    "translationStatus": "en_missing; explicit_it_fallback_required",
    "languages": {
      "it": {
        "title": "Sistema per Identificazione microbica ed antibiogramma – Mindray",
        "slug": "mindray-af-300",
        "route": "/it/prodotti/microbiologia/mindray-af-300",
        "sourceUrl": "https://www.esamed.it/prodotti/microbiologia/mindray-af-300/",
        "sourceWpId": 4227,
        "sourceDate": "2024-03-08T10:20:31",
        "sourceModified": "2026-04-28T16:47:09",
        "media": [
          "/media/source/images/sistema-AF-1.png",
          "/media/source/images/piastre_kit.png",
          "/media/source/images/AF-300.png",
          "/media/source/images/AP-100.png"
        ],
        "primaryMedia": "/media/source/images/sistema-AF-1.png"
      }
    }
  },
  {
    "id": "prd-cpa-easynat-real-time-molecular-diagnostic-system-vet",
    "categoryId": "cat-poct",
    "batch": "07D",
    "translationStatus": "it_en_source_available",
    "languages": {
      "it": {
        "title": "CPA EasyNAT -Ustar",
        "slug": "cpa-easynat-real-time-molecular-diagnostic-system-vet",
        "route": "/it/prodotti/point-of-care-testing/cpa-easynat-real-time-molecular-diagnostic-system-vet",
        "sourceUrl": "https://www.esamed.it/prodotti/point-of-care-testing/cpa-easynat-real-time-molecular-diagnostic-system-vet/",
        "sourceWpId": 4100,
        "sourceDate": "2023-08-04T15:39:40",
        "sourceModified": "2026-04-28T17:23:08",
        "media": [
          "/media/source/images/Easynat.png",
          "/media/source/images/Easynat-kit.png",
          "/media/source/images/CPA-workflow-1-scaled.png",
          "/media/source/images/test-CPA.png"
        ],
        "primaryMedia": "/media/source/images/Easynat.png"
      },
      "en": {
        "title": "CPA EasyNAT® Real-Time Molecular Diagnostic System",
        "slug": "cpa-easynat",
        "route": "/en/products/point-of-care-testing/cpa-easynat",
        "sourceUrl": "https://www.esamed.it/en/products/sistemi-di-prelievo/cpa-easynat/",
        "sourceWpId": 3451,
        "sourceDate": "2021-06-08T16:07:21",
        "sourceModified": "2021-11-03T16:05:52",
        "media": [
          "/media/source/images/cpa_4.png",
          "/media/source/images/5-cAOYiDRSiwZ9rWETN1nQ.jpg",
          "/media/source/images/1_proc-155x300.jpg",
          "/media/source/images/1_proc.jpg",
          "/media/source/images/2_proc-271x300.jpg",
          "/media/source/images/2_proc.jpg",
          "/media/source/images/3_proc-300x188.png",
          "/media/source/images/3_proc.png"
        ],
        "primaryMedia": "/media/source/images/cpa_4.png"
      }
    }
  },
  {
    "id": "prd-centrifuga-domel-centric-350",
    "categoryId": "cat-laboratory-equipment",
    "batch": "07A1",
    "translationStatus": "en_missing; explicit_it_fallback_required",
    "languages": {
      "it": {
        "title": "Centrifuga Centric 350 – Domel",
        "slug": "centrifuga-domel-centric-350",
        "route": "/it/prodotti/attrezzature-da-laboratorio/centrifuga-domel-centric-350",
        "sourceUrl": "https://www.esamed.it/prodotti/attrezzature-da-laboratorio/centrifuga-domel-centric-350/",
        "sourceWpId": 4061,
        "sourceDate": "2023-07-04T11:43:08",
        "sourceModified": "2026-04-28T10:27:20",
        "media": [
          "/media/source/images/centrifuga-350-1.png",
          "/media/source/images/350-tabella.png"
        ],
        "primaryMedia": "/media/source/images/centrifuga-350-1.png"
      }
    }
  },
  {
    "id": "prd-esaliva-dispositivo-per-la-raccolta-della-saliva",
    "categoryId": "cat-collection-systems",
    "batch": "07F",
    "translationStatus": "it_en_source_available",
    "languages": {
      "it": {
        "title": "ESAliva – Esamed",
        "slug": "esaliva-dispositivo-per-la-raccolta-della-saliva",
        "route": "/it/prodotti/sistemi-di-prelievo/esaliva-dispositivo-per-la-raccolta-della-saliva",
        "sourceUrl": "https://www.esamed.it/prodotti/sistemi-di-prelievo/esaliva-dispositivo-per-la-raccolta-della-saliva/",
        "sourceWpId": 4036,
        "sourceDate": "2023-05-09T18:21:35",
        "sourceModified": "2026-04-30T16:40:50",
        "media": [
          "/media/source/images/ESAliva.png"
        ],
        "primaryMedia": "/media/source/images/ESAliva.png"
      },
      "en": {
        "title": "ESALiva – ESAMED",
        "slug": "esaliva-saliva-collection-device",
        "route": "/en/products/collection-systems/esaliva-saliva-collection-device",
        "sourceUrl": "https://www.esamed.it/en/products/collection-systems/esaliva-saliva-collection-device/",
        "sourceWpId": 4037,
        "sourceDate": "2023-05-09T18:21:35",
        "sourceModified": "2026-04-30T16:40:14",
        "media": [
          "/media/source/images/ESAliva.png"
        ],
        "primaryMedia": "/media/source/images/ESAliva.png"
      }
    }
  },
  {
    "id": "prd-dc-2000-sl-stappatore",
    "categoryId": "cat-preanalytics",
    "batch": "06",
    "translationStatus": "it_en_source_available",
    "languages": {
      "it": {
        "title": "DC 2000 SL – ENDMED",
        "slug": "dc-2000-sl-stappatore",
        "route": "/it/prodotti/preanalitica/dc-2000-sl-stappatore",
        "sourceUrl": "https://www.esamed.it/prodotti/preanalitica/dc-2000-sl-stappatore/",
        "sourceWpId": 3995,
        "sourceDate": "2023-04-24T10:19:43",
        "sourceModified": "2026-04-24T16:35:42",
        "media": [
          "/media/source/images/DC2000SL-1.png"
        ],
        "primaryMedia": "/media/source/images/DC2000SL-1.png"
      },
      "en": {
        "title": "DC 2000 SL – Decapper",
        "slug": "dc-2000-sl-stappatore",
        "route": "/en/products/preanalytics/dc-2000-sl-stappatore",
        "sourceUrl": "https://www.esamed.it/en/products/sistemi-di-prelievo/dc-2000-sl-stappatore/",
        "sourceWpId": 3996,
        "sourceDate": "2023-04-24T10:19:43",
        "sourceModified": "2023-04-24T10:40:03",
        "media": [
          "/media/source/images/DC2000SL-1.png"
        ],
        "primaryMedia": "/media/source/images/DC2000SL-1.png"
      }
    }
  },
  {
    "id": "prd-eugenio",
    "categoryId": "cat-preanalytics",
    "batch": "07E",
    "translationStatus": "it_en_source_available",
    "languages": {
      "it": {
        "title": "Eugenio – ESAMED",
        "slug": "eugenio",
        "route": "/it/prodotti/preanalitica/eugenio",
        "sourceUrl": "https://www.esamed.it/prodotti/preanalitica/eugenio/",
        "sourceWpId": 3812,
        "sourceDate": "2022-11-04T14:13:44",
        "sourceModified": "2026-04-24T16:47:59",
        "media": [
          "/media/source/images/Eugenio-Esamed-1.png",
          "/media/source/images/EugenioAperto-scaled.jpg",
          "/media/source/images/Eugenio-1940-scaled.jpg",
          "/media/source/images/Eugenio-1974-scaled.jpg"
        ],
        "primaryMedia": "/media/source/images/Eugenio-Esamed-1.png"
      },
      "en": {
        "title": "Eugenio – Automatic tube barcode reader",
        "slug": "eugenio",
        "route": "/en/products/preanalytics/eugenio",
        "sourceUrl": "https://www.esamed.it/en/products/sistemi-di-prelievo/eugenio/",
        "sourceWpId": 3813,
        "sourceDate": "2022-11-04T14:13:44",
        "sourceModified": "2022-11-21T08:42:10",
        "media": [
          "/media/source/images/Eugenio-Esamed-1.png",
          "/media/source/images/EugenioAperto-scaled.jpg",
          "/media/source/images/Eugenio-1940-scaled.jpg",
          "/media/source/images/Eugenio-1974-scaled.jpg"
        ],
        "primaryMedia": "/media/source/images/Eugenio-Esamed-1.png"
      }
    }
  },
  {
    "id": "prd-x12-pro-semen-analysis-system",
    "categoryId": "cat-infertility",
    "batch": "06",
    "translationStatus": "en_source_image_only; textual_translation_required",
    "languages": {
      "it": {
        "title": "X12 PRO Semen Analysis System – Bonraybio",
        "slug": "x12-pro-semen-analysis-system",
        "route": "/it/prodotti/infertilita/x12-pro-semen-analysis-system",
        "sourceUrl": "https://www.esamed.it/prodotti/infertilita/x12-pro-semen-analysis-system/",
        "sourceWpId": 3749,
        "sourceDate": "2022-08-04T15:47:41",
        "sourceModified": "2026-04-28T16:15:24",
        "media": [
          "/media/source/images/X12-1.png"
        ],
        "primaryMedia": "/media/source/images/X12-1.png"
      },
      "en": {
        "title": "X12 PRO Semen Analysis System",
        "slug": "x12-pro-semen-analysis-system",
        "route": "/en/products/infertility/x12-pro-semen-analysis-system",
        "sourceUrl": "https://www.esamed.it/en/products/sistemi-di-prelievo/x12-pro-semen-analysis-system/",
        "sourceWpId": 3750,
        "sourceDate": "2022-08-04T15:47:41",
        "sourceModified": "2022-08-04T16:18:17",
        "media": [
          "/media/source/images/X12-1.png"
        ],
        "primaryMedia": "/media/source/images/X12-1.png"
      }
    }
  },
  {
    "id": "prd-accessori-prelievo",
    "categoryId": "cat-collection-systems",
    "batch": "07F",
    "translationStatus": "en_missing; explicit_it_fallback_required",
    "languages": {
      "it": {
        "title": "Accessori per il prelievo – BD",
        "slug": "accessori_prelievo",
        "route": "/it/prodotti/sistemi-di-prelievo/accessori_prelievo",
        "sourceUrl": "https://www.esamed.it/prodotti/sistemi-di-prelievo/accessori_prelievo/",
        "sourceWpId": 3435,
        "sourceDate": "2021-04-02T16:03:11",
        "sourceModified": "2026-04-24T16:06:41",
        "media": [
          "/media/source/images/accessori-prelievo-1.png"
        ],
        "primaryMedia": "/media/source/images/accessori-prelievo-1.png"
      }
    }
  },
  {
    "id": "prd-provette-bd",
    "categoryId": "cat-collection-systems",
    "batch": "07F",
    "translationStatus": "en_missing; explicit_it_fallback_required",
    "languages": {
      "it": {
        "title": "Provette Vacutainer – BD",
        "slug": "provette-bd",
        "route": "/it/prodotti/sistemi-di-prelievo/provette-bd",
        "sourceUrl": "https://www.esamed.it/prodotti/sistemi-di-prelievo/provette-bd/",
        "sourceWpId": 3415,
        "sourceDate": "2021-04-02T12:55:23",
        "sourceModified": "2026-04-24T16:05:33",
        "media": [
          "/media/source/images/ProvetteBD-Rack-3.png",
          "/media/source/logos/bectondickenson_logo.png",
          "/media/source/images/ProvetteBD.png"
        ],
        "primaryMedia": "/media/source/images/ProvetteBD-Rack-3.png"
      }
    }
  },
  {
    "id": "prd-esatrace",
    "categoryId": "cat-transport-systems",
    "batch": "07G2",
    "translationStatus": "it_en_source_available",
    "languages": {
      "it": {
        "title": "Esatrace sistema per il monitoraggio dei trasporti – Esamed",
        "slug": "esatrace",
        "route": "/it/prodotti/soluzioni-per-trasporto/esatrace",
        "sourceUrl": "https://www.esamed.it/prodotti/soluzioni-per-trasporto/esatrace/",
        "sourceWpId": 2869,
        "sourceDate": "2020-10-12T12:55:24",
        "sourceModified": "2026-04-28T15:48:29",
        "media": [
          "/media/source/logos/Logo-ESAtrace.png",
          "/media/source/images/DATALOGGER.png",
          "/media/source/images/1-Esatrace-check-out.jpg",
          "/media/source/images/2-Esatrace-check-in.jpg",
          "/media/source/images/3-Esatrace-esito.jpg",
          "/media/source/images/4-Esatrace-monitoraggio-missioni.jpg"
        ],
        "primaryMedia": "/media/source/logos/Logo-ESAtrace.png"
      },
      "en": {
        "title": "Esatrace – ESAMED",
        "slug": "esatrace",
        "route": "/en/products/transport-systems/esatrace",
        "sourceUrl": "https://www.esamed.it/en/products/transport-systems/esatrace/",
        "sourceWpId": 3092,
        "sourceDate": "2020-10-12T12:55:24",
        "sourceModified": "2026-04-30T14:23:50",
        "media": [
          "/media/source/logos/Logo-ESAtrace.png"
        ],
        "primaryMedia": "/media/source/logos/Logo-ESAtrace.png"
      }
    }
  },
  {
    "id": "prd-portaprovette",
    "categoryId": "cat-preanalytics",
    "batch": "07E",
    "translationStatus": "en_missing; explicit_it_fallback_required",
    "languages": {
      "it": {
        "title": "Portaprovette da laboratorio – Esamed",
        "slug": "portaprovette",
        "route": "/it/prodotti/preanalitica/portaprovette",
        "sourceUrl": "https://www.esamed.it/prodotti/preanalitica/portaprovette/",
        "sourceWpId": 2867,
        "sourceDate": "2020-10-12T12:45:24",
        "sourceModified": "2026-04-24T17:05:46",
        "media": [
          "/media/source/images/rack-esamed-1.png",
          "/media/source/images/rack-rosso-3.png"
        ],
        "primaryMedia": "/media/source/images/rack-esamed-1.png"
      }
    }
  },
  {
    "id": "prd-contenitori-terziari-esamed",
    "categoryId": "cat-transport-systems",
    "batch": "07G1",
    "translationStatus": "en_missing; explicit_it_fallback_required",
    "languages": {
      "it": {
        "title": "Contenitori terziari – Esamed",
        "slug": "contenitori-terziari-esamed",
        "route": "/it/prodotti/soluzioni-per-trasporto/contenitori-terziari-esamed",
        "sourceUrl": "https://www.esamed.it/prodotti/soluzioni-per-trasporto/contenitori-terziari-esamed/",
        "sourceWpId": 2854,
        "sourceDate": "2020-10-12T12:03:52",
        "sourceModified": "2026-04-28T15:06:06",
        "media": [
          "/media/source/images/Contenitori-terziari-Esamed-1.png",
          "/media/source/images/trasporti.png",
          "/media/source/images/ES-BIO-2.png",
          "/media/source/images/ES-EMO-2.png",
          "/media/source/images/ES-FAB-2.png",
          "/media/source/images/ES-GEN-1.png"
        ],
        "primaryMedia": "/media/source/images/Contenitori-terziari-Esamed-1.png"
      }
    }
  },
  {
    "id": "prd-contenitore-secondario-bios-campioni-biologici",
    "categoryId": "cat-transport-systems",
    "batch": "07G1",
    "translationStatus": "it_en_source_available",
    "languages": {
      "it": {
        "title": "Contenitori secondari BIOS – ESAMED",
        "slug": "contenitore-secondario-bios-campioni-biologici",
        "route": "/it/prodotti/soluzioni-per-trasporto/contenitore-secondario-bios-campioni-biologici",
        "sourceUrl": "https://www.esamed.it/prodotti/soluzioni-per-trasporto/contenitore-secondario-bios-campioni-biologici/",
        "sourceWpId": 2850,
        "sourceDate": "2020-10-12T11:50:59",
        "sourceModified": "2026-04-30T14:59:09",
        "media": [
          "/media/source/images/ES-BIOS-M.png",
          "/media/source/images/BIOS.png",
          "/media/source/images/ES-BIOS-L.png"
        ],
        "primaryMedia": "/media/source/images/ES-BIOS-M.png"
      },
      "en": {
        "title": "BIOS Secondary Containers – ESAMED",
        "slug": "bios",
        "route": "/en/products/transport-systems/bios",
        "sourceUrl": "https://www.esamed.it/en/products/transport-systems/bios/",
        "sourceWpId": 4773,
        "sourceDate": "2026-04-09T12:05:15",
        "sourceModified": "2026-04-30T15:01:58",
        "media": [
          "/media/source/images/ES-BIOS-L.png"
        ],
        "primaryMedia": "/media/source/images/ES-BIOS-L.png"
      }
    }
  },
  {
    "id": "prd-frigoriferi-medicali",
    "categoryId": "cat-laboratory-equipment",
    "batch": "07A2",
    "translationStatus": "en_missing; explicit_it_fallback_required",
    "languages": {
      "it": {
        "title": "Frigoriferi medicali – Evermed",
        "slug": "frigoriferi_medicali",
        "route": "/it/prodotti/attrezzature-da-laboratorio/frigoriferi_medicali",
        "sourceUrl": "https://www.esamed.it/prodotti/attrezzature-da-laboratorio/frigoriferi_medicali/",
        "sourceWpId": 2818,
        "sourceDate": "2020-10-09T17:53:49",
        "sourceModified": "2026-04-28T10:41:25",
        "media": [
          "/media/source/images/frigoriferi-medicali-evermed-1.png",
          "/media/source/images/MPR-2.png",
          "/media/source/images/LR-3.png"
        ],
        "primaryMedia": "/media/source/images/frigoriferi-medicali-evermed-1.png"
      }
    }
  },
  {
    "id": "prd-x1-pro-se-semen-quality-analyzer",
    "categoryId": "cat-collection-systems",
    "batch": "07F",
    "translationStatus": "it_missing; en_source_image_only",
    "languages": {
      "en": {
        "title": "X1 PRO SE Semen Quality Analyzer",
        "slug": "x1-pro-se-semen-quality-analyzer",
        "route": "/en/products/collection-systems/x1-pro-se-semen-quality-analyzer",
        "sourceUrl": "https://www.esamed.it/en/products/sistemi-di-prelievo/x1-pro-se-semen-quality-analyzer/",
        "sourceWpId": 3738,
        "sourceDate": "2022-08-04T14:49:50",
        "sourceModified": "2022-08-04T15:29:47",
        "media": [
          "/media/source/images/semen1-1.png",
          "/media/source/images/semen3.jpg",
          "/media/source/images/semen4.jpg",
          "/media/source/images/X1.e304-en-ver2153_____-12.jpg"
        ],
        "primaryMedia": "/media/source/images/semen1-1.png"
      }
    }
  }
] as const;

export const publicNews: readonly PublicContentRecord[] = [
  {
    "id": "news-simti-2026-workshop-esamed",
    "categoryId": "news",
    "batch": "08",
    "translationStatus": "it_en_source_available",
    "languages": {
      "it": {
        "title": "SIMTI 2026 – WORKSHOP ESAMED",
        "slug": "simti-2026-workshop-esamed",
        "route": "/it/news?article=simti-2026-workshop-esamed",
        "sourceUrl": "https://www.esamed.it/simti-2026-workshop-esamed/",
        "sourceWpId": 4974,
        "sourceDate": "2026-04-23T14:53:12",
        "sourceModified": "2026-04-23T14:56:18",
        "media": [
          "/media/source/images/1.jpg",
          "/media/source/images/2.jpg"
        ],
        "primaryMedia": "/media/source/images/1.jpg"
      },
      "en": {
        "title": "ESAMED WORKSHOP – SIMTI 2026",
        "slug": "esamed-workshop-simti-2026",
        "route": "/en/news?article=esamed-workshop-simti-2026",
        "sourceUrl": "https://www.esamed.it/en/esamed-workshop-simti-2026/",
        "sourceWpId": 5316,
        "sourceDate": "2026-05-04T11:26:28",
        "sourceModified": "2026-05-04T11:26:28",
        "media": [
          "/media/source/images/2.jpg"
        ],
        "primaryMedia": "/media/source/images/2.jpg"
      }
    }
  },
  {
    "id": "news-simti-2026",
    "categoryId": "news",
    "batch": "08",
    "translationStatus": "it_en_source_available",
    "languages": {
      "it": {
        "title": "SIMTI 2026",
        "slug": "simti-2026",
        "route": "/it/news?article=simti-2026",
        "sourceUrl": "https://www.esamed.it/simti-2026/",
        "sourceWpId": 4970,
        "sourceDate": "2026-04-23T14:52:54",
        "sourceModified": "2026-04-23T14:52:54",
        "media": [
          "/media/source/images/SIMTI-2026.png"
        ],
        "primaryMedia": "/media/source/images/SIMTI-2026.png"
      },
      "en": {
        "title": "SIMTI 2026",
        "slug": "5312",
        "route": "/en/news?article=5312",
        "sourceUrl": "https://www.esamed.it/en/5312/",
        "sourceWpId": 5312,
        "sourceDate": "2026-05-04T11:22:50",
        "sourceModified": "2026-05-04T11:23:07",
        "media": [
          "/media/source/images/SIMTI-2026.png"
        ],
        "primaryMedia": "/media/source/images/SIMTI-2026.png"
      }
    }
  },
  {
    "id": "news-amcli-2026",
    "categoryId": "news",
    "batch": "08",
    "translationStatus": "it_en_source_available",
    "languages": {
      "it": {
        "title": "AMCLI 2026",
        "slug": "amcli-2026",
        "route": "/it/news?article=amcli-2026",
        "sourceUrl": "https://www.esamed.it/amcli-2026/",
        "sourceWpId": 4748,
        "sourceDate": "2026-04-08T10:49:46",
        "sourceModified": "2026-04-08T11:29:47",
        "media": [
          "/media/source/images/AMCLI-5.jpeg",
          "/media/source/images/AMCLI-2.jpeg",
          "/media/source/images/AMCLI-1.jpeg",
          "/media/source/images/AMCLI-4.jpeg"
        ],
        "primaryMedia": "/media/source/images/AMCLI-5.jpeg"
      },
      "en": {
        "title": "AMCLI 2026",
        "slug": "5310",
        "route": "/en/news?article=5310",
        "sourceUrl": "https://www.esamed.it/en/5310/",
        "sourceWpId": 5310,
        "sourceDate": "2026-05-04T11:20:49",
        "sourceModified": "2026-05-04T11:24:26",
        "media": [
          "/media/source/images/AMCLI-5.jpeg",
          "/media/source/images/AMCLI-4.jpeg",
          "/media/source/images/AMCLI-2.jpeg",
          "/media/source/images/AMCLI-1.jpeg"
        ],
        "primaryMedia": "/media/source/images/AMCLI-5.jpeg"
      }
    }
  },
  {
    "id": "news-medlab-middle-east-2024",
    "categoryId": "news",
    "batch": "08",
    "translationStatus": "it_en_source_available",
    "languages": {
      "it": {
        "title": "Medlab Middle East 2024",
        "slug": "medlab-middle-east-2024",
        "route": "/it/news?article=medlab-middle-east-2024",
        "sourceUrl": "https://www.esamed.it/medlab-middle-east-2024/",
        "sourceWpId": 4179,
        "sourceDate": "2024-02-06T15:19:15",
        "sourceModified": "2024-02-07T10:00:36",
        "media": [
          "/media/source/images/image001-300x235.png",
          "/media/source/images/image001-768x602.png",
          "/media/source/images/image001.png",
          "/media/source/images/image_3A1000010895_0x0_1720x2040-253x300.png",
          "/media/source/images/image_3A1000010895_0x0_1720x2040-863x1024.png",
          "/media/source/images/image_3A1000010895_0x0_1720x2040-768x911.png",
          "/media/source/images/image_3A1000010895_0x0_1720x2040-1295x1536.png",
          "/media/source/images/image_3A1000010895_0x0_1720x2040-1064x1262.png",
          "/media/source/images/image_3A1000010895_0x0_1720x2040.png"
        ],
        "primaryMedia": "/media/source/images/image001.png"
      },
      "en": {
        "title": "Medlab Middle East 2024",
        "slug": "medlab-middle-east-2024",
        "route": "/en/news?article=medlab-middle-east-2024",
        "sourceUrl": "https://www.esamed.it/en/medlab-middle-east-2024/",
        "sourceWpId": 4194,
        "sourceDate": "2024-02-06T17:05:37",
        "sourceModified": "2024-02-06T17:06:50",
        "media": [
          "/media/source/images/image001.png",
          "/media/source/images/image001-300x235.png",
          "/media/source/images/image001-768x602.png",
          "/media/source/images/image_3A1000010895_0x0_1720x2040-253x300.png",
          "/media/source/images/image_3A1000010895_0x0_1720x2040-863x1024.png",
          "/media/source/images/image_3A1000010895_0x0_1720x2040-768x911.png",
          "/media/source/images/image_3A1000010895_0x0_1720x2040-1295x1536.png",
          "/media/source/images/image_3A1000010895_0x0_1720x2040-1064x1262.png",
          "/media/source/images/image_3A1000010895_0x0_1720x2040.png"
        ],
        "primaryMedia": "/media/source/images/image001.png"
      }
    }
  },
  {
    "id": "news-nuovi-prodotti-di-preanalitica-decapper-e-recapper",
    "categoryId": "news",
    "batch": "08",
    "translationStatus": "it_en_source_available",
    "languages": {
      "it": {
        "title": "Nuovi prodotti di preanalitica: decapper e recapper",
        "slug": "nuovi-prodotti-di-preanalitica-decapper-e-recapper",
        "route": "/it/news?article=nuovi-prodotti-di-preanalitica-decapper-e-recapper",
        "sourceUrl": "https://www.esamed.it/nuovi-prodotti-di-preanalitica-decapper-e-recapper/",
        "sourceWpId": 3945,
        "sourceDate": "2023-01-20T16:28:09",
        "sourceModified": "2023-01-20T17:32:47",
        "media": [
          "/media/source/images/decapper-1.jpg"
        ],
        "primaryMedia": "/media/source/images/decapper-1.jpg"
      },
      "en": {
        "title": "New preanalytics products: detapper and recapper",
        "slug": "new-preanalytics-products-detapper-and-recapper",
        "route": "/en/news?article=new-preanalytics-products-detapper-and-recapper",
        "sourceUrl": "https://www.esamed.it/en/new-preanalytics-products-detapper-and-recapper/",
        "sourceWpId": 3956,
        "sourceDate": "2023-01-20T16:46:02",
        "sourceModified": "2023-01-20T17:33:24",
        "media": [
          "/media/source/images/decapper-1.jpg"
        ],
        "primaryMedia": "/media/source/images/decapper-1.jpg"
      }
    }
  },
  {
    "id": "news-convegno-poct-udine",
    "categoryId": "news",
    "batch": "08",
    "translationStatus": "it_en_source_available",
    "languages": {
      "it": {
        "title": "Convegno POCT Udine",
        "slug": "convegno-poct-udine",
        "route": "/it/news?article=convegno-poct-udine",
        "sourceUrl": "https://www.esamed.it/convegno-poct-udine/",
        "sourceWpId": 3914,
        "sourceDate": "2022-12-21T10:39:55",
        "sourceModified": "2022-12-21T11:16:44",
        "media": [
          "/media/source/images/poct_conv.png",
          "/media/source/images/cong1.png",
          "/media/source/images/cong2.png",
          "/media/source/images/cong3.png"
        ],
        "primaryMedia": "/media/source/images/poct_conv.png"
      },
      "en": {
        "title": "POCT Conference in Udine",
        "slug": "poct-conference-in-udine",
        "route": "/en/news?article=poct-conference-in-udine",
        "sourceUrl": "https://www.esamed.it/en/poct-conference-in-udine/",
        "sourceWpId": 3935,
        "sourceDate": "2022-12-21T11:04:42",
        "sourceModified": "2022-12-21T11:16:44",
        "media": [
          "/media/source/images/poct_conv.png",
          "/media/source/images/cong1.png",
          "/media/source/images/cong2.png",
          "/media/source/images/cong3.png"
        ],
        "primaryMedia": "/media/source/images/poct_conv.png"
      }
    }
  },
  {
    "id": "news-articolo-de-osservatorio-gruppo24ore",
    "categoryId": "news",
    "batch": "08",
    "translationStatus": "en_missing; explicit_it_fallback_required",
    "languages": {
      "it": {
        "title": "Articolo de ‘Osservatorio – Gruppo24ore’",
        "slug": "articolo-de-osservatorio-gruppo24ore",
        "route": "/it/news?article=articolo-de-osservatorio-gruppo24ore",
        "sourceUrl": "https://www.esamed.it/articolo-de-osservatorio-gruppo24ore/",
        "sourceWpId": 3852,
        "sourceDate": "2022-11-09T12:25:55",
        "sourceModified": "2022-11-09T12:39:27",
        "media": [
          "/media/source/images/giornale_imm.png"
        ],
        "primaryMedia": "/media/source/images/giornale_imm.png"
      }
    }
  },
  {
    "id": "news-eugenio-lettore-automatico-barcode-delle-provette",
    "categoryId": "news",
    "batch": "08",
    "translationStatus": "it_en_source_available",
    "languages": {
      "it": {
        "title": "Eugenio – Lettore automatico barcode delle provette",
        "slug": "eugenio-lettore-automatico-barcode-delle-provette",
        "route": "/it/news?article=eugenio-lettore-automatico-barcode-delle-provette",
        "sourceUrl": "https://www.esamed.it/eugenio-lettore-automatico-barcode-delle-provette/",
        "sourceWpId": 3833,
        "sourceDate": "2022-11-08T14:59:56",
        "sourceModified": "2022-11-08T14:59:56",
        "media": [],
        "primaryMedia": null
      },
      "en": {
        "title": "Eugenio – Automatic tubes barcode reader",
        "slug": "eugenio-automatic-tubes-barcode-reader",
        "route": "/en/news?article=eugenio-automatic-tubes-barcode-reader",
        "sourceUrl": "https://www.esamed.it/en/eugenio-automatic-tubes-barcode-reader/",
        "sourceWpId": 3835,
        "sourceDate": "2022-11-08T15:05:08",
        "sourceModified": "2022-11-08T15:06:32",
        "media": [],
        "primaryMedia": null
      }
    }
  },
  {
    "id": "news-medica-2022",
    "categoryId": "news",
    "batch": "08",
    "translationStatus": "it_en_source_available",
    "languages": {
      "it": {
        "title": "Medica 2022",
        "slug": "medica-2022",
        "route": "/it/news?article=medica-2022",
        "sourceUrl": "https://www.esamed.it/medica-2022/",
        "sourceWpId": 3712,
        "sourceDate": "2022-07-18T13:20:13",
        "sourceModified": "2022-07-18T13:23:22",
        "media": [
          "/media/source/images/home-1.jpg",
          "/media/source/images/2022_MEDICA_2375x500_150-scaled.jpg"
        ],
        "primaryMedia": "/media/source/images/home-1.jpg"
      },
      "en": {
        "title": "Medica 2022",
        "slug": "medica-2022",
        "route": "/en/news?article=medica-2022",
        "sourceUrl": "https://www.esamed.it/en/medica-2022/",
        "sourceWpId": 3724,
        "sourceDate": "2022-07-18T15:27:34",
        "sourceModified": "2022-07-18T15:29:13",
        "media": [
          "/media/source/images/home-1.jpg",
          "/media/source/images/2022_MEDICA_2375x500_150-scaled.jpg"
        ],
        "primaryMedia": "/media/source/images/home-1.jpg"
      }
    }
  },
  {
    "id": "news-nuove-strumentazioni-veterinaria",
    "categoryId": "news",
    "batch": "08",
    "translationStatus": "it_en_source_available",
    "languages": {
      "it": {
        "title": "Nuove Strumentazioni Veterinaria",
        "slug": "nuove-strumentazioni-veterinaria",
        "route": "/it/news?article=nuove-strumentazioni-veterinaria",
        "sourceUrl": "https://www.esamed.it/nuove-strumentazioni-veterinaria/",
        "sourceWpId": 3677,
        "sourceDate": "2022-05-31T13:08:02",
        "sourceModified": "2022-05-31T13:15:42",
        "media": [],
        "primaryMedia": null
      },
      "en": {
        "title": "New veterinary equipment",
        "slug": "new-veterinary-equipment",
        "route": "/en/news?article=new-veterinary-equipment",
        "sourceUrl": "https://www.esamed.it/en/new-veterinary-equipment/",
        "sourceWpId": 3691,
        "sourceDate": "2022-05-31T13:17:43",
        "sourceModified": "2022-05-31T13:17:44",
        "media": [],
        "primaryMedia": null
      }
    }
  },
  {
    "id": "news-il-nostro-stand-scivac-rimini",
    "categoryId": "news",
    "batch": "08",
    "translationStatus": "it_en_source_available",
    "languages": {
      "it": {
        "title": "Il nostro stand SCIVAC Rimini",
        "slug": "il-nostro-stand-scivac-rimini",
        "route": "/it/news?article=il-nostro-stand-scivac-rimini",
        "sourceUrl": "https://www.esamed.it/il-nostro-stand-scivac-rimini/",
        "sourceWpId": 3645,
        "sourceDate": "2022-05-28T15:24:13",
        "sourceModified": "2022-05-28T15:33:13",
        "media": [
          "/media/source/images/standd.jpeg",
          "/media/source/images/standdd.jpeg"
        ],
        "primaryMedia": "/media/source/images/standd.jpeg"
      },
      "en": {
        "title": "Our stand at the SCIVAC Rimini",
        "slug": "our-stand-at-the-scivac-rimini",
        "route": "/en/news?article=our-stand-at-the-scivac-rimini",
        "sourceUrl": "https://www.esamed.it/en/our-stand-at-the-scivac-rimini/",
        "sourceWpId": 3663,
        "sourceDate": "2022-05-28T15:41:57",
        "sourceModified": "2022-05-30T15:48:09",
        "media": [
          "/media/source/images/standd.jpeg",
          "/media/source/images/standdd.jpeg"
        ],
        "primaryMedia": "/media/source/images/standd.jpeg"
      }
    }
  },
  {
    "id": "news-test-per-il-vaiolo-delle-scimmie",
    "categoryId": "news",
    "batch": "08",
    "translationStatus": "it_en_source_available",
    "languages": {
      "it": {
        "title": "Test per il vaiolo delle scimmie",
        "slug": "test-per-il-vaiolo-delle-scimmie",
        "route": "/it/news?article=test-per-il-vaiolo-delle-scimmie",
        "sourceUrl": "https://www.esamed.it/test-per-il-vaiolo-delle-scimmie/",
        "sourceWpId": 3638,
        "sourceDate": "2022-05-27T09:36:25",
        "sourceModified": "2022-05-30T16:39:34",
        "media": [],
        "primaryMedia": null
      },
      "en": {
        "title": "Monkeypox test",
        "slug": "monkeypox-test",
        "route": "/en/news?article=monkeypox-test",
        "sourceUrl": "https://www.esamed.it/en/monkeypox-test/",
        "sourceWpId": 3642,
        "sourceDate": "2022-05-27T09:40:59",
        "sourceModified": "2022-05-27T09:41:00",
        "media": [],
        "primaryMedia": null
      }
    }
  },
  {
    "id": "news-scivac-rimini-2022",
    "categoryId": "news",
    "batch": "08",
    "translationStatus": "it_en_source_available",
    "languages": {
      "it": {
        "title": "SCIVAC RIMINI 2022",
        "slug": "scivac-rimini-2022",
        "route": "/it/news?article=scivac-rimini-2022",
        "sourceUrl": "https://www.esamed.it/scivac-rimini-2022/",
        "sourceWpId": 3599,
        "sourceDate": "2022-05-04T12:42:56",
        "sourceModified": "2022-05-06T15:46:16",
        "media": [
          "/media/source/images/esamed_scivac-5.png"
        ],
        "primaryMedia": "/media/source/images/esamed_scivac-5.png"
      },
      "en": {
        "title": "SCIVAC RIMINI 2022",
        "slug": "scivac-rimini-2022",
        "route": "/en/news?article=scivac-rimini-2022",
        "sourceUrl": "https://www.esamed.it/en/scivac-rimini-2022/",
        "sourceWpId": 3619,
        "sourceDate": "2022-05-06T15:36:43",
        "sourceModified": "2022-05-06T15:51:03",
        "media": [
          "/media/source/images/esamed_scivac-5.png"
        ],
        "primaryMedia": "/media/source/images/esamed_scivac-5.png"
      }
    }
  },
  {
    "id": "news-soluzioni-complete-per-diagnostica-covid-19",
    "categoryId": "news",
    "batch": "08",
    "translationStatus": "it_en_source_available",
    "languages": {
      "it": {
        "title": "Soluzioni complete per diagnostica Covid-19",
        "slug": "soluzioni-complete-per-diagnostica-covid-19",
        "route": "/it/news?article=soluzioni-complete-per-diagnostica-covid-19",
        "sourceUrl": "https://www.esamed.it/soluzioni-complete-per-diagnostica-covid-19/",
        "sourceWpId": 3533,
        "sourceDate": "2022-01-12T12:39:15",
        "sourceModified": "2022-01-12T14:25:05",
        "media": [],
        "primaryMedia": null
      },
      "en": {
        "title": "Complete solutions for Covid-19 diagnostics",
        "slug": "complete-solutions-for-covid-19-diagnostics",
        "route": "/en/news?article=complete-solutions-for-covid-19-diagnostics",
        "sourceUrl": "https://www.esamed.it/en/complete-solutions-for-covid-19-diagnostics/",
        "sourceWpId": 3546,
        "sourceDate": "2022-01-12T14:33:23",
        "sourceModified": "2022-01-12T14:33:25",
        "media": [],
        "primaryMedia": null
      }
    }
  },
  {
    "id": "news-fornitura-emergency-poct",
    "categoryId": "news",
    "batch": "08",
    "translationStatus": "it_en_source_available",
    "languages": {
      "it": {
        "title": "Fornitura Emergency POCT",
        "slug": "fornitura-emergency-poct",
        "route": "/it/news?article=fornitura-emergency-poct",
        "sourceUrl": "https://www.esamed.it/fornitura-emergency-poct/",
        "sourceWpId": 3480,
        "sourceDate": "2021-08-06T11:34:26",
        "sourceModified": "2021-08-06T11:40:48",
        "media": [
          "/media/source/logos/Logo_Emergency2-1.gif"
        ],
        "primaryMedia": "/media/source/logos/Logo_Emergency2-1.gif"
      },
      "en": {
        "title": "POCT Emergency suppliers",
        "slug": "poct-emergency-suppliers",
        "route": "/en/news?article=poct-emergency-suppliers",
        "sourceUrl": "https://www.esamed.it/en/poct-emergency-suppliers/",
        "sourceWpId": 3489,
        "sourceDate": "2021-08-06T11:44:42",
        "sourceModified": "2021-08-06T11:44:43",
        "media": [
          "/media/source/logos/Logo_Emergency2-1.gif"
        ],
        "primaryMedia": "/media/source/logos/Logo_Emergency2-1.gif"
      }
    }
  },
  {
    "id": "news-cpa-easynat-real-time-molecular-diagnostic-system",
    "categoryId": "news",
    "batch": "08",
    "translationStatus": "it_en_source_available",
    "languages": {
      "it": {
        "title": "CPA EASYNAT® REAL-TIME MOLECULAR DIAGNOSTIC SYSTEM",
        "slug": "cpa-easynat-real-time-molecular-diagnostic-system",
        "route": "/it/news?article=cpa-easynat-real-time-molecular-diagnostic-system",
        "sourceUrl": "https://www.esamed.it/cpa-easynat-real-time-molecular-diagnostic-system/",
        "sourceWpId": 3460,
        "sourceDate": "2021-06-14T15:56:24",
        "sourceModified": "2022-01-12T12:27:00",
        "media": [
          "/media/source/images/cpa_4.png"
        ],
        "primaryMedia": "/media/source/images/cpa_4.png"
      },
      "en": {
        "title": "CPA EASYNAT® REAL-TIME MOLECULAR DIAGNOSTIC SYSTEM",
        "slug": "cpa-easynat-real-time-molecular-diagnostic-system",
        "route": "/en/news?article=cpa-easynat-real-time-molecular-diagnostic-system",
        "sourceUrl": "https://www.esamed.it/en/cpa-easynat-real-time-molecular-diagnostic-system/",
        "sourceWpId": 3464,
        "sourceDate": "2021-06-14T16:01:42",
        "sourceModified": "2022-01-12T12:28:54",
        "media": [
          "/media/source/images/cpa_4.png"
        ],
        "primaryMedia": "/media/source/images/cpa_4.png"
      }
    }
  },
  {
    "id": "news-covid-19-sp-anticorpi-neutralizzanti",
    "categoryId": "news",
    "batch": "08",
    "translationStatus": "it_en_source_available",
    "languages": {
      "it": {
        "title": "Covid-19 SP anticorpi neutralizzanti",
        "slug": "covid-19-sp-anticorpi-neutralizzanti",
        "route": "/it/news?article=covid-19-sp-anticorpi-neutralizzanti",
        "sourceUrl": "https://www.esamed.it/covid-19-sp-anticorpi-neutralizzanti/",
        "sourceWpId": 3399,
        "sourceDate": "2021-04-02T11:18:35",
        "sourceModified": "2021-04-02T11:25:09",
        "media": [],
        "primaryMedia": null
      },
      "en": {
        "title": "Covid-19 SP immune responses",
        "slug": "covid-19-sp-immune-responses",
        "route": "/en/news?article=covid-19-sp-immune-responses",
        "sourceUrl": "https://www.esamed.it/en/covid-19-sp-immune-responses/",
        "sourceWpId": 3407,
        "sourceDate": "2021-04-02T11:32:42",
        "sourceModified": "2021-04-02T11:36:52",
        "media": [],
        "primaryMedia": null
      }
    }
  },
  {
    "id": "news-frend-nanoentek",
    "categoryId": "news",
    "batch": "08",
    "translationStatus": "it_en_source_available",
    "languages": {
      "it": {
        "title": "FREND NANOENTEK",
        "slug": "frend-nanoentek",
        "route": "/it/news?article=frend-nanoentek",
        "sourceUrl": "https://www.esamed.it/frend-nanoentek/",
        "sourceWpId": 3332,
        "sourceDate": "2021-02-08T15:56:07",
        "sourceModified": "2021-02-10T17:14:06",
        "media": [],
        "primaryMedia": null
      },
      "en": {
        "title": "FREND NANOENTEK",
        "slug": "frend-nanoentek",
        "route": "/en/news?article=frend-nanoentek",
        "sourceUrl": "https://www.esamed.it/en/frend-nanoentek/",
        "sourceWpId": 3350,
        "sourceDate": "2021-02-10T17:24:13",
        "sourceModified": "2021-02-10T17:25:59",
        "media": [],
        "primaryMedia": null
      }
    }
  }
] as const;
